import { useEffect } from 'react';

export function PageTitle({ children }: { children: string }) {
  useEffect(() => {
    document.title = children;
  }, [children]);
  return null;
}
